export const generateSubscriptionId = ({ subId, start, expires, promoId = '', quota = 1, type, period = '' }) => {
    return subId || start + (expires + quota) + type + period + promoId;
};
